
<Button state="icon" :size="computedValue.size" :type="computedValue.type" @click="handleClick">
	<Icon
		:name="computedValue.icon.name"
		:type="computedValue.icon.type || 'filled'"
		:size="computedValue.icon.size || 'small'"
		:state="computedValue.icon.state || 'dark'"
		:effects="false"
	/>
</Button>
